/**
 * Maps CAS `CloseContactSuggestion` values to the corresponding
 * contact sub-status name in the CRM.
 */
export const casCloseContactSubStatusMap = {
  spam: 'spam',
  empty_email: 'leeg/afwezig',
  empty_mail: 'leeg/afwezig',
  thank_you: 'bedanking',
  informational: 'ter info',
  test: 'test',
};

export const ALLOWED_CAS_CLOSE_SUGGESTIONS = Object.keys(
  casCloseContactSubStatusMap,
);
